import React, { useMemo } from 'react'
import * as managers from 'modules/domain/company/managers'
import { EntityMultiSelect, EntityMultiSelectProps } from 'views/components/EntitySelect/EntityMultiSelect'
import { SelectTestWrapper } from '../SelectTestWrapper/SelectTestWrapper'
import { PedigreedSeedTerritory, PedigreedSeedTerritoryListRequestFilter } from 'modules/domain/company/types'

export type PedigreedSeedTerritorySelectProps = EntityMultiSelectProps<PedigreedSeedTerritory> & {
  details?: PedigreedSeedTerritoryListRequestFilter['details']
}

export const getPedigreedSeedTerritoryLabel = (pedigreedSeedTerritory: PedigreedSeedTerritory) =>
  pedigreedSeedTerritory.details
export const getPedigreedSeedTerritoryValue = (pedigreedSeedTerritory: PedigreedSeedTerritory) =>
  pedigreedSeedTerritory.id

const PedigreedSeedTerritorySelect: React.FC<PedigreedSeedTerritorySelectProps> = ({
  details,
  placeholder,
  ...props
}) => {
  const memoizedFilter = useMemo(
    () => ({
      details,
    }),
    [details],
  )

  return (
    <SelectTestWrapper data-test-id={'pedigreed-seed-territory-select'}>
      <EntityMultiSelect
        placeholder={placeholder || 'Select Pedigreed Seed Territory'}
        getEntityList={managers.fetchPedigreedSeedTerritory}
        getEntityByIds={managers.getPedigreedSeedTerritoryByIds}
        filter={memoizedFilter}
        getOptionLabel={getPedigreedSeedTerritoryLabel}
        getOptionValue={getPedigreedSeedTerritoryValue}
        searchParamKey="title"
        {...props}
      />
    </SelectTestWrapper>
  )
}

export default PedigreedSeedTerritorySelect
